import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { clearAllSearch } from "../../../redux/actions/user";
import { clearResults } from "../../../redux/actions/search";
import Page from "../../index";
import Container from "../container";
import LandingTop from "./components/LandingTop";
import { Mixpanel } from "../../../components/shared/Mixpanel";
import LandingPageWrapper from "./index.style";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import getLatest from "../../../redux/actions/publisher/handlers/getLatest";
import { LoadingSpinner } from "../../../components/common";
import Pilar from "./components/Pilar";
import HelpWithLicense from "./components/HelpWithLicense";
import Ugc from "./components/Ugc";
import VideoSubmission from "./components/VideoSubmission";
import Brand from "./components/Brand";
import OfficeLocation from "./components/OfficeLocation";
import Hero from "./components/Hero";

export function LicensingHome(props) {
  const { clearAllSearch, auth, history, getLatest, publisher } = props;
  const { homepage } = publisher;

  React.useEffect(() => {
    Mixpanel.track("View Home Page");
    window.scrollTo({ top: 0 });
    getLatest();
  }, []);

  return (
    <Page
      id="licensing"
      title="License the Best Viral Videos and UGC Footage"
      description="Browse and license from the world's most up-to-date and comprehensive footage library of user-generated and viral video clips."
      contentType="website"
    >
      {publisher.fetching ? (
        <LoadingSpinner className="loading-symbol loading">
          <div />
        </LoadingSpinner>
      ) : (
        <Container headerSticky={true}>
          <LandingPageWrapper>
            <Hero clearAllSearch={clearAllSearch} heroTitle={homepage.heroTitle} />
            <HelpWithLicense />
            <Ugc />
            <Brand />
            <VideoSubmission />
            <OfficeLocation />
          </LandingPageWrapper>
        </Container>
      )}
    </Page>
  );
}

LicensingHome.propTypes = {
  clearAllSearch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
};

export default connect(
  (state) => ({
    auth: state.auth,
    publisher: state.publisher,
    search: state.search,
    user: state.user
  }),
  {
    clearAllSearch,
    clearResults,
    getLatest
  }
)(LicensingHome);
